import * as st from './heroshot.module.scss'
import * as React from 'react'
import { CirclePlayButton } from '../circlePlayButton/circlePlayButton'
import { CirclePlayButtonPlaceholder } from '../circlePlayButton/circlePlayButtonPlaceholder'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { Packshot } from './packshot'
import { ResponsiveImage } from '../images/responsiveImage'
import { SrcSize } from '../../utils/imageUtils'

const HEROSHOT_MOBILE_WIDTH = 360
const HEROSHOT_TABLET_WIDTH = 720
const HEROSHOT_DESKTOP_WIDTH = 1080

export interface IHeroshotProps {
  heroshot?: string
  packshot?: string
  playbackData?: WpsRuntime.atv.wps.PlaybackActionDataProps
  sessionId: string
  pageTitleId: string
  isRetail: boolean
  isTV: boolean
  isDeeplinkableActionReady: boolean
}

export const Heroshot = ({ heroshot, packshot, playbackData, sessionId, pageTitleId, isRetail, isTV, isDeeplinkableActionReady}: IHeroshotProps) => {
  if (!heroshot) {
    return <Packshot packshot={packshot} playbackData={playbackData} sessionId={sessionId} pageTitleId={pageTitleId} isRetail={isRetail} isTV={isTV} />
  }

  const heroshotImgProps = {
    alt: '', // Decorative image so no alt
    src: heroshot,
    baseValue: HEROSHOT_DESKTOP_WIDTH,
    srcSizes: [
      { 'max-phablet': HEROSHOT_MOBILE_WIDTH },
      { 'max-tablet': HEROSHOT_TABLET_WIDTH },
      {'min-tablet': HEROSHOT_DESKTOP_WIDTH}
    ] as SrcSize[]
  }

  return (
    <React.Fragment>
      <div className={`${st.avHeroBackground} ${st.heroshotOpacity} av-hero-background`}
           data-automation-id="hero-background">
        <div className={st.imageFadeWrapper}>
          <ResponsiveImage className={`${st.heroshot}`} {...heroshotImgProps} />
          <div className={st.avHeroBackgroundFadeLeft}/>
          <div className={st.avHeroBackgroundFadeBottom}/>
        </div>
        {isRetail && (
          <div className="playback-large-circle-wrapper">
            <div id="dv-play-box-circle">
              {isDeeplinkableActionReady && playbackData && (
                <CirclePlayButton {...{playbackData, sessionId, pageTitleId, isRetail}}/>
              )}
            </div>
          </div>
        )}
      </div>
      <CirclePlayButtonPlaceholder />
    </React.Fragment>
  )
}
